<template>
    <g>
        <path style="fill:#281F1F;" d="M72.8,42.6C72.8,43.9,72.8,43,72.8,42.6L72.8,42.6z"/>
        <path style="fill:#281F1F;" d="M72.8,42.6L72.8,42.6L72.8,42.6C72.8,42.6,72.8,42.7,72.8,42.6z"/>
        <path style="fill:#281F1F;" d="M72.8,42.6c0-1.8,0.2-4.8-2-5.7c-1.9-0.7-4.7-0.3-6.6,0c-2.3,0.4-4.4,1.1-6.4,2.1c-2.2,1.1-4,1.9-6.5,0.7
			c-2-1-3.9-2-6.2-2.5s-5.1-0.9-7.4-0.5c-2.1,0.4-2.7,2.5-2.8,4.1c-0.2,3.5-0.3,8.6,4,10c2.2,0.7,4.7,0.8,6.9,0.5
			c2.3-0.3,3.4-1.9,4.5-3.6c0.8-1.2,1.4-3.9,3.2-4.2c1.5-0.3,2.3,1.4,2.8,2.4c0.8,1.6,2.1,4.2,4.1,5s4.4,0.6,6.5,0.3
			c1.8-0.2,3.8-0.8,4.7-2.4c1.1-1.9,1.2-4.4,1.2-6.5C72.8,42.5,72.8,42.6,72.8,42.6s0-0.1,0-0.2C72.8,42.5,72.8,42.5,72.8,42.6z"/>
    </g>
</template>

<script>
    export default {
        name: 'Eye16',
    }
</script>

<style scoped>

</style>
